import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  budget: yup.number()
    .required('Budget is required')
    .min(20, 'Budget must be greater or equal to 20'),
});
